export default __webpack_public_path__ + "static/cardTabImg3-501d8bb83a266f13d6ed02252c89bb3d.webp";